import { useContext } from 'react'
import { cwqDialogContext } from './cwqDialogContext'

export function useCWQDialogContext() {
  const context = useContext(cwqDialogContext)

  if (!context) throw Error('Must be a child of CWQDialogContextProvider')

  return context
}
